import { Col, Row, Label } from "reactstrap";
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  calendarNonWorkingDayCreate,
  calendarNonWorkingDayCreateSuccess,
  calendarNonWorkingDayList,
  calendarNonWorkingDayUpdate,
  calendarNonWorkingDayUpdateSuccess,
  staffHolidayCalendarCreate,
  staffHolidayCalendarCreateSuccess,
  staffHolidayCalendarList,
  staffHolidayCalendarPeriodCreate,
  staffHolidayCalendarPeriodCreateSuccess,
  staffHolidayCalendarPeriodList,
  staffHolidayCalendarPeriodUpdate,
  staffHolidayCalendarPeriodUpdateSuccess,
  staffHolidayCalendarUpdate,
  staffHolidayCalendarUpdateSuccess,
} from "../../../store/staffLeave/action";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import AppModal from "../../Common/AppModal";
import HandleDateTime, {
  handleDateFormat,
  handleValidDateTime,
} from "../../Common/HandleDateTime";
import { AppDateTimePicker } from "../../Common/AppDateTimePicker";
import moment from "moment";
import handleDateTime from "../../Common/HandleDateTime";

export default function CreateEditStaffHolidayNonWorkingDayConfig({
  modal,
  setModal,
  toggle,
  isEdit,
  updateData,
}) {
  const dispatch = useDispatch();

  const initialData = {
    Name: "",
    Description: "",
    StartDateTime: "",
    EndDateTime: "",
    FlagAllDay: "1",
    FlagPublicHoliday: "1",
  };

  const [data, setData] = useState(initialData);

  useEffect(() => {
    if (!isEdit) return;
    if (isEmpty(updateData)) return;
    setData({
      Id: updateData?.Id,
      Name: updateData?.Name,
      Description: updateData?.Description,
      StartDateTime: updateData?.StartDateTime,
      EndDateTime: updateData?.EndDateTime,
      FlagAllDay: updateData?.FlagAllDay,
      FlagPublicHoliday: updateData?.FlagPublicHoliday,
    });
  }, [updateData, isEdit]);

  const handleCreateUpdateData = (type) => {
    // check
    // if (isEmpty(data.QtyOfHoursInSingleDay)) {
    //   toast.error("Qty Of Hours In Single Day is required");
    //   return;
    // }
    if (type === "create") {
      dispatch(calendarNonWorkingDayCreate([data]));
    }
    if (type === "update") {
      dispatch(calendarNonWorkingDayUpdate([data]));
    }
  };

  const {
    CreateSUCCESS,
    UpdateSUCCESS,
    calendarNonWorkingDayCreateLoading,
    calendarNonWorkingDayUpdateLoading,
  } = useSelector((state) => ({
    CreateSUCCESS: state.StaffLeave.calendarNonWorkingDayCreate,
    UpdateSUCCESS: state.StaffLeave.calendarNonWorkingDayUpdate,
    calendarNonWorkingDayCreateLoading:
      state.StaffLeave.calendarNonWorkingDayCreateLoading,
    calendarNonWorkingDayUpdateLoading:
      state.StaffLeave.calendarNonWorkingDayUpdateLoading,
  }));

  //Create
  useEffect(() => {
    if (isEmpty(CreateSUCCESS)) return;
    if (CreateSUCCESS.status === 200) {
      toast.success(CreateSUCCESS.message);
      setModal(false);
      dispatch(calendarNonWorkingDayList());
    } else {
      toast.error(CreateSUCCESS.message);
    }
    dispatch(calendarNonWorkingDayCreateSuccess([]));
  }, [CreateSUCCESS]);

  //Update
  useEffect(() => {
    if (isEmpty(UpdateSUCCESS)) return;
    if (UpdateSUCCESS.status === 200) {
      toast.success(UpdateSUCCESS.message);
      setModal(false);
      dispatch(calendarNonWorkingDayList());
    } else {
      toast.error(UpdateSUCCESS.message);
    }
    dispatch(calendarNonWorkingDayUpdateSuccess([]));
  }, [UpdateSUCCESS]);

  const { staffHolidayCalendarListAPI, staffHolidayCalendarPeriodDataLoading } =
    useSelector((state) => ({
      staffHolidayCalendarListAPI:
        state.StaffLeave.staffHolidayCalendarList?.staffholidaycalendar_list,
      staffHolidayCalendarPeriodDataLoading:
        state.StaffLeave.staffHolidayCalendarListLoading,
    }));
  console.log("staffHolidayCalendarListAPI", staffHolidayCalendarListAPI);
  return (
    <AppModal
      open={modal}
      onClose={toggle}
      title={
        isEdit
          ? "Edit Calendar Non Working Day"
          : "Create Calendar Non Working Day"
      }
      icon={<EventBusyOutlinedIcon />}
      headerAccent="indigo"
      size="sm"
      loading={
        calendarNonWorkingDayCreateLoading || calendarNonWorkingDayUpdateLoading
      }
      loadingText="Saving…"
      submitLabel={isEdit ? "Update" : "Create"}
      submitColor="success"
      onSubmit={() =>
        isEdit
          ? handleCreateUpdateData("update")
          : handleCreateUpdateData("create")
      }
    >
      <Row className="g-3">
            <Col lg={12}>
              <div className={"d-flex flex-column p-2"}>
                <Label>Name</Label>
                <input
                  type={"text"}
                  className={"form-control"}
                  value={data.Name}
                  onChange={(e) => setData({ ...data, Name: e.target.value })}
                />
              </div>
              <div className={"d-flex flex-column p-2"}>
                <Label>Description</Label>
                <input
                  type={"text"}
                  className={"form-control"}
                  value={data.Description}
                  onChange={(e) =>
                    setData({ ...data, Description: e.target.value })
                  }
                />
              </div>
              <div className={"d-flex flex-column p-2"}>
                <Label>Start Date</Label>
                <AppDateTimePicker
                  value={
                    data?.StartDateTime
                      ? moment(data?.StartDateTime, "YYYY-MM-DD HH:mm:ss")
                      : null
                  }
                  onChange={(val) => {
                    const jsDate = val && val.isValid() ? val.toDate() : null;
                    setData({
                      ...data,
                      StartDateTime: jsDate ? handleValidDateTime(jsDate) : "",
                    });
                  }}
                />
              </div>
              <div className={"d-flex flex-column p-2"}>
                <Label>EndDate Date</Label>
                <AppDateTimePicker
                  value={
                    data?.EndDateTime
                      ? moment(data?.EndDateTime, "YYYY-MM-DD HH:mm:ss")
                      : null
                  }
                  onChange={(val) => {
                    const jsDate = val && val.isValid() ? val.toDate() : null;
                    setData({
                      ...data,
                      EndDateTime: jsDate ? handleValidDateTime(jsDate) : "",
                    });
                  }}
                />
              </div>
              <div className={"d-flex flex-row p-2"}>
                <input
                  type={"checkbox"}
                  className={" me-1"}
                  checked={data.FlagAllDay === "1"}
                  onChange={(e) =>
                    setData({
                      ...data,
                      FlagAllDay: e.target.checked ? "1" : "0",
                    })
                  }
                />
                <span>Flag All Day</span>
              </div>
              <div className={"d-flex flex-row p-2"}>
                <input
                  type={"checkbox"}
                  className={" me-1"}
                  checked={data.FlagPublicHoliday === "1"}
                  onChange={(e) =>
                    setData({
                      ...data,
                      FlagPublicHoliday: e.target.checked ? "1" : "0",
                    })
                  }
                />
                <span>Public Holiday ?</span>
              </div>
              {/*[*/}
              {/*{*/}
              {/*    "Name": "{{$randomWords}}",*/}
              {/*    "Description": "{{$randomLoremParagraph}}",*/}
              {/*    "FlagAutoOpenUponRenewal": 1,*/}
              {/*    "DaysToOpenNextRenewal": 90,*/}
              {/*    "StartDateDay": 1,*/}
              {/*    "StartDateMonth": 1,*/}
              {/*    "EndDateDay": 31,*/}
              {/*    "EndDateMonth": 12,*/}
              {/*    "QtyOfHoursInSingleDay": 7.5*/}
              {/*}*/}
              {/*]*/}
            </Col>
          </Row>
    </AppModal>
  );
}
